import { render, staticRenderFns } from "./RequestExchange.vue?vue&type=template&id=21bfd21b&scoped=true&"
import script from "./RequestExchange.vue?vue&type=script&lang=js&"
export * from "./RequestExchange.vue?vue&type=script&lang=js&"
import style0 from "./RequestExchange.vue?vue&type=style&index=0&id=21bfd21b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfd21b",
  null
  
)

export default component.exports